import { useContext, useRef } from 'react';
import ArrowLeft from '../../../assets/icons/ArrowLeft';
import ArrowRight from '../../../assets/icons/ArrowRight';
import Button from '../../../ui/Button';
import OverlayCard from '../../../ui/OverlayCard';
import Heading from '../../../ui/Heading';
import ClaimedCertificate from './ClaimedCertificate';
import ClaimedCertificateBack from './ClaimedCertificateBack';
import { ProfileContext } from '../../../contexts/ProfileContext';
import NoDataAvailable from '../../../ui/NoDataAvailable';

function AllClaimedCards({ askToConnectWallet, setAskToConnectWallet }) {
    const { state } = useContext(ProfileContext);
    const claimedIcs = state.filter((ic) => ic.status === 'CLAIMED');
    const scrollCards = useRef();
    function scrollR() {
        scrollCards.current.scrollBy({
            left: 334,
            behavior: 'smooth',
        });
    }
    function scrollL() {
        scrollCards.current.scrollBy({
            left: -334,
            behavior: 'smooth',
        });
    }
    console.log(claimedIcs, 'see claimed ICS', setAskToConnectWallet);
    return (
        <div className="mt-8">
            <Heading className={`text-textGrayHeading leading-10`} type={'medium'}>
                Claimed
            </Heading>
            <div className="relative">
                <div
                    verticalMargin=""
                    ref={scrollCards}
                    className="  flex items-center overflow-auto   scrollableCards"
                >
                    {claimedIcs.length > 0 ? (
                        claimedIcs.map((ic) => {
                            return (
                                <OverlayCard
                                    width="w-[346px]"
                                    height="h-[378px]"
                                    fixW="w-[346px]"
                                    key={ic.id + ic.status}
                                    image={ic.image}
                                    certificateId={ic.id}
                                    ic={ic}
                                    setAskToConnectWallet={setAskToConnectWallet}
                                    FrontCard={ClaimedCertificate}
                                    BackCard={ClaimedCertificateBack}
                                />
                            );
                        })
                    ) : (
                        <div className="flex w-full items-center justify-center">
                            <NoDataAvailable marginTop="mt-3" />
                        </div>
                    )}
                </div>

                <Button
                    radius="rounded-full"
                    onClick={scrollL}
                    className="bg-[#EAEAEA] absolute top-[50%] translate-y-[-50%]  -left-[3.15rem] "
                    variant="tertiary"
                    size="circle"
                >
                    <ArrowLeft fillColor="#606060" />
                </Button>

                <Button
                    radius="rounded-full"
                    onClick={scrollR}
                    className="bg-[#EAEAEA] absolute top-[50%] translate-y-[-50%]  -right-[3.15rem] "
                    variant="tertiary"
                    size="circle"
                >
                    <ArrowRight fillColor={'#606060'} />
                </Button>
            </div>
        </div>
    );
}

export default AllClaimedCards;
